import ArticlePanel from './ArticlePanel';

export default ArticlePanel;
